export class InstancesCounters {
  constructor(
    private readonly all: number,
    private readonly high: number,
    private readonly medium: number,
    private readonly low: number,
    private readonly passed: number
  ) {}

  getAll() {
    return this.all;
  }

  getHigh() {
    return this.high;
  }

  getMedium() {
    return this.medium;
  }

  getLow() {
    return this.low;
  }

  getPassed() {
    return this.passed;
  }

  getNotKept() {
    return this.all - this.high - this.medium - this.low - this.passed;
  }
}
